const DITypes = {
  FileDownloadLinkGenerator: Symbol('DmPortalFileDownloadLinkGenerator'),
};

export default DITypes;
